// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */

import React from 'react';
import styles from './LoadingSpinner.css';

/**
 * An animated loading spinner that doesn't use ta-green
 */
const LoadingSpinner = () => (
  <svg className={styles.loadingSpinner} viewBox="0 0 32 32">
    <path className={styles.circle} d="M 16 2 A 14 14 0 1 0 30 16" />
  </svg>
);

export default LoadingSpinner;
